module.exports = __webpack_public_path__ + "static/img/example.b6a920e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/example.png
// module id = V6cW
// module chunks = 22